<template>
  <section class="housemaid-policy-form flex-1">
    <lazy-dom>
      <el-form
        ref="form"
        :rules="formRules"
        :disabled="showBuyable"
        :model="formData">
        <div
          v-if="isCancel"
          class="box">
          <h3></h3>
          <div
            class="flex-sb">
            <div class="form-item form-half">
              <span>Cancellation Effective Date</span>
              <el-form-item
                ref="pcy_expry_dt"
                :prop="checkRefer===1?'':'pcy_expry_dt'">
                <v-date-picker
                  v-model="formData.pcy_expry_dt"
                />
              </el-form-item>

            </div>
          </div>
        </div>
        <div class="box">
          <h2>Policy Details</h2>
          <div class="flex-sb travel-group">
            <div class="form-item form-half">
              <span>Destination</span>
              <el-form-item
                prop="destination_id">
                <v-select
                  v-model="formData.destination_id"
                  :disabled="isCancel"
                  :list="localAllOptions.from_hk_to" />
              </el-form-item>
            </div>

          </div>
          <!--          <div class="flex-sb">-->
          <!--            <div class="form-item form-half">-->
          <!--              <span>Effective Date</span>-->
          <!--              <el-form-item-->
          <!--                prop="pcy_cmnt_dt">-->
          <!--                <v-date-picker-->
          <!--                  v-model="formData.pcy_cmnt_dt"-->
          <!--                />-->
          <!--              </el-form-item>-->
          <!--            </div>-->

          <!--          </div>-->
          <div
            v-if="!isCancel"
            class="flex-sb">
            <div class="form-item form-half">
              <span>{{ isCancel? 'Cancellation Effective Date':(isEndorsement? 'Endorsement Effective Date': 'Expected Effective Date') }}</span>
              <el-form-item
                v-if="isCancel"
                ref="pcy_expry_dt"
                :prop="checkRefer===1?'':'pcy_expry_dt'">
                <v-date-picker
                  v-model="formData.pcy_expry_dt"
                  :_45daysComfirm='true'
                />
              </el-form-item>
              <el-form-item
                v-else
                ref="pcy_cmnt_dt"
                :prop="checkRefer===1?'':'pcy_cmnt_dt'">
                <v-date-picker
                  v-model="formData.pcy_cmnt_dt"
                  :_45daysComfirm='true'
                />
              </el-form-item>
            </div>
          </div>
          <div
            v-if="!isCancel"
            class="form-item form-half">
            <span>Expected Expiry Date </span>
            <el-form-item
            >
              <v-date-picker
                :value="endDate"
                disabled/>
            </el-form-item>
          </div>
        </div>
        <div
          v-if="isRefer&&insuredItems.length>0"
          class="box">
          <h3>Insured Items</h3>
          <div class="form-item option_checkout">
            <v-checkbox-group
              v-model="formData.benefits"
              :isColumn="false"
              :list="localAllOptions.benefits" />
          </div>
        </div>
        <div
          v-if="benefitList.length>0&&!isRefer"
          class="box">
          <!--          <h2>Insured Items</h2>-->
          <div
            class="form-item form-half">
            <span>Insured Items</span>
            <el-form-item
            >
              <v-checkbox-group
                v-model="formData.benefits"
                :list="benefitList"
                :isColumn="false"
                @change="handlerExtra"
              />
            </el-form-item>
          </div>
        </div>
        <div class="box">
          <h2>Policyholder Details</h2>
          <div class="flex-sb">
            <div class="form-item form-half">
              <span>Title</span>
              <el-form-item
                ref="isrd_title"
                prop="isrd_title">
                <v-select
                  v-model="formData.isrd_title"
                  :list="titleOptions"
                  :disabled="isCancel||checkDisabled('isrd_title')"
                />
              </el-form-item>
            </div>
          </div>
          <div class="form-item form-half">
            <span>Last Name</span>
            <el-form-item
              ref="isrd_lst_nm"
              prop="isrd_lst_nm">
              <v-input
                v-model="formData.isrd_lst_nm"
                uppercase
                :disabled="isCancel||checkDisabled('isrd_lst_nm')"/>
            </el-form-item>
          </div>
          <div class="form-item form-half">
            <span>First Name</span>
            <el-form-item
              ref="isrd_fst_nm"
              prop="isrd_fst_nm">
              <v-input
                v-model="formData.isrd_fst_nm"
                uppercase
                :disabled="isCancel||checkDisabled('isrd_fst_nm')"/>
            </el-form-item>
          </div>
          <div class="flex-sb">

            <div class="form-half">
              <div class="form-item">
                <span>{{formData.id_type==2?'Passport':'HKID'}} Number</span>
                <el-form-item
                  ref="id_type"
                >
                  <v-radio-group
                    v-model="formData.id_type"
                    :disabled="isCancel||checkDisabled('id_type')"
                    :list="personalIdTypOptions" />
                </el-form-item>
                <el-form-item
                  v-if="formData.id_type==1"
                  ref="id_no"
                >
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    placeholder="A123456(3), please input A1234563"
                    :disabled="isCancel||checkDisabled('id_no')"
                    class="mg-t-5" />
                </el-form-item>
                <el-form-item
                  v-else
                  ref="id_no"
                >
                  <v-input
                    v-model="formData.id_no"
                    uppercase
                    :disabled="isCancel||checkDisabled('id_no')"
                    class="mg-t-5" />
                </el-form-item>
              </div>
              <div class="form-item">
                <span>Date of Birth</span>
                <el-form-item prop="isrd_dob">
                  <v-birth-day
                    v-model="formData.isrd_dob"
                    :disabled="isCancel||checkDisabled('isrd_dob')"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="form-item form-half">
            <span>Email</span>
            <el-form-item
              ref="email"
              prop="email"
              :rules="rules.email">
              <v-input
                v-model="formData.email"
                :disabled="isCancel||checkDisabled('email')"/>
            </el-form-item>
          </div>
          <div class="flex-sb">

            <div class="form-item form-half">
              <span>Mobile Number</span>
              <el-form-item
                ref="mobile_no"
                prop="mobile_no">
                <v-input
                  v-model="formData.mobile_no"
                  :disabled="isCancel||checkDisabled('mobile_no')"
                  key-number
                  maxlength="8"
                />
              </el-form-item>
            </div>
          </div>
          <span class="title">Correspondence Address</span>
          <address-form
            ref="address-form"
            :formType="1"
            :formDataLock="formDataLock"
            :form="addressForm"
            :notValid="checkRefer===2?false:true"
            :disabled="isCancel||showBuyable"
            @getFormData="getAddressForm" />
        </div>

        <div class="box">
          <h2>Upload Document</h2>
          <div class="flex-sb">
            <div
              v-if="editType==3"
              class="form-item form-half">
              <span >Renewal Letter（Insurer）</span>
              <el-form-item
                ref="renewal_letter_insurer_path_id"
                prop="renewal_letter_insurer_path_id">
                <v-upload
                  :card="true"
                  ::disabled="isCancel||showBuyable"
                  :fileData="formData.renewal_letter_insurer"
                  :otherData="{
                    target: 'renewal_letter_insurer',
                    idKey: 'renewal_letter_insurer_path_id',
                    nameKey: 'renewal_letter_insurer_path',
                    type:'renewal_letter_insurer_path'
                  }"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess" />
              </el-form-item>
            </div>
            <div class="form-item form-half">
              <span>Policyholder HKID</span>
              <el-form-item
                ref="id_type_pic_path_id"
                prop="id_type_pic_path_id">
                <v-upload
                  :card="true"
                  :disabled="isCancel||showBuyable"
                  :fileData="formData.id_type_pic"
                  :file-list="fileList"
                  :otherData="{
                    target: 'id_type_pic',
                    idKey: 'id_type_pic_path_id',
                    nameKey: 'id_type_pic_path',
                    type:'id_type_pic_path'
                  }"
                  @delete="handlerDeleteFile"
                  @uploadSuccess="handlerUploadSuccess"
                />
              </el-form-item>
            </div>
          </div>
        <!--        <div class="form-item">-->
        <!--          <span>Additional Documents</span>-->
        <!--          <file-container-->
        <!--            v-for="(item, index) in formData.other_file"-->
        <!--            :key="index"-->
        <!--            :fileData="item"-->
        <!--            :otherData="{-->
        <!--              index,-->
        <!--              type: 'other'-->
        <!--            }" -->
        <!--            :edit="true"-->
        <!--            @delete="handlerDeleteFile"-->
        <!--            @uploadSuccess="handlerUploadSuccess"-->
        <!--          />-->
        <!--          <v-upload-->
        <!--            :otherData="{-->
        <!--              type: 'other',-->
        <!--            }" -->
        <!--            @uploadSuccess="handlerUploadSuccess" />-->
        <!--        </div>-->
        </div>

      </el-form>
    </lazy-dom>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import AddressForm from '@/views/components/address-form'
import MixinSame from '@/mixins/same'

export default {
  name: 'WorkingPolicyForm',
  components: {
    AddressForm
  },
  mixins: [MixinOptions, MixinFormat, MixinRules,MixinSame],
  props: {
    form: {
      type: Object,
      default: null
    },
    editType:{
      type:Number,
      default:0
    },
    checkRefer:{
      type:Number,
      default:0
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isEndorsement: {
      type: Boolean,
      default: false
    },
    showBuyable: {
      type: Boolean,
      default: false
    },
    isRefer: {
      type: Boolean,//refer case 显示insured item 全部选项
      default: false
    },
    editQuote:{
      type: Boolean,
      default: false
    }
  },
  data() {
    const checkBirth3 = (rule, value, callback) => {
      let {pcy_cmnt_dt} = this.formData
      const birth = dayjs(pcy_cmnt_dt).format('YYYY-MM-DD') || ( Date.now() + 1000 * 60 * 60 * 24)
      let msTime = new Date(value).getTime()
      let above18 = dayjs(value).add(18, 'year').format('YYYY-MM-DD')
      // if(msTime > Date.now()) {
      //   callback( new Error( '出生日期不得大於當前日期' ) )
      // }
      if(new Date(above18).getTime() > new Date(birth).getTime()) {
        callback( new Error('申請人必須年滿18歲' ) )
      }
      callback()
    }
    return {
      formData: {
        class_id: '',
        isrd_title: '',
        isrd_lst_nm: '',
        isrd_fst_nm: '',
        mobile_no: '',
        isrd_dob_date: '',
        email: '',
        isrd_dob: '',
        id_no: '',
        pcy_cmnt_dt: '',
        pcy_expry_dt: '',
        destination_id: '',

        id_type_pic_path: '',
        id_type_pic_path_id: '',
        id_type:1,
        other_file: [],
        id_type_pic: {},
        benefits: [],
        renewal_letter_insurer_path: '',
        renewal_letter_insurer_path_id: '',
        renewal_letter_insurer: {},
      },
      formDataLock: 0,
      otherData: {},
      subForm: {
        'address-form': false,
      },
      addressForm: {
        addr_room: '',
        addr_floor: '',
        addr_block: '',
        addr_building: '',
        addr_street: '',
        addr_district: '',
        addr_area: '',
        addr_region: '',
      },
      extraRules: {
        isrd_dob:[
          { validator: checkBirth3, trigger: ['blur'] }
        ]
      }
    }
  },
  computed: {
    benefitList(){
      let {quote_coverage_list} =this.form||{}
      let {kyc_benefit=[]} = quote_coverage_list||{}
      let arr = []
      if(this.editQuote){
        arr = JSON.parse(JSON.stringify(this[`allOptions${this.formData.class_id}`].benefits))
      }else{
        kyc_benefit.some(item=>{
          // if(item.is_selected==1)
          //   this.formData.benefits.push(item.id)
          if(item.is_show!==0){
            arr.push({name:item.name,id:item.id})
          }
        })
      }
      return arr||[]
    },
    localAllOptions() {
      return this.allOptions22
    },
    insuredItems(){
      let {benefits=[]} = this.allOptions22
      return benefits||[]
    },
    endDate(){
      let {company_id,plan_id,pcy_expry_dt,pcy_period,ins_end_dt}  =this.form
      let {pcy_cmnt_dt=''}  =this.formData
      let date = ''
      // if(company_id==22&&plan_id==1){
      //   date = dayjs(pcy_cmnt_dt).add(6,'month').subtract(1,'day').format('YYYY-MM-DD')
      // }else{
      //   date = dayjs(pcy_cmnt_dt).add(1,'year').subtract(1,'day').format('YYYY-MM-DD')
      // }
      // if(this.isEndorsement)
      //   date = pcy_expry_dt
      if(pcy_period==0)
        date = pcy_expry_dt
      else
        date=pcy_cmnt_dt? dayjs(pcy_cmnt_dt).add(pcy_period,'month').subtract(1,'day').format('YYYY-MM-DD'):''
      if(this.isEndorsement)
        date = ins_end_dt?ins_end_dt:pcy_expry_dt

      this.formData.pcy_expry_dt = date
      return date
    },
    formRules() {
      let rulesOption = JSON.stringify(this.rules)
      rulesOption = JSON.parse(rulesOption)

      Object.keys(rulesOption).some(keys => {
        rulesOption[keys][0].required = false
      })

      Object.keys(this.ruleRequestData).some(key => {
        // Object.keys(rulesOption).some(keys => {
        //   if(key==keys)
        rulesOption[key][0].required = true
        // })
      })
      return this.checkRefer ===2 ? this.rules : rulesOption
      // return this.rules
    },
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          const formValue = JSON.parse(JSON.stringify(val))
          this.formData = Object.assign(
            this.formData,
            formValue
          )
          let {quote_coverage_list} = this.formData||{}
          let {kyc_benefit=[]} = quote_coverage_list||{}
          kyc_benefit.some(item=>{
            if(item.is_selected==1)
              this.formData.benefits.push(item.id)
          })
          this.formData.benefits= [...new Set( this.formData.benefits)]
          // if(formValue.id_type != 1) {
          //   this.formData.id_no = ''
          // }
          if(formValue.id_type_pic) {
            const { path, id } = val.id_type_pic
            this.formData.id_type_pic_path = path
            this.formData.id_type_pic_path_id = id
          }
          this.handler().handlerAddress(formValue)
        }
      }
    },
  },
  methods: {
    handlerExtra(){
      let {extra_benefits,pcy_cmnt_dt,benefits} = this.formData
      let params = {
        extra_benefits,
        pcy_cmnt_dt,
        benefits
      }
      this.$emit('changeCompute',params)
    },
    checkDisabled(field) {
      const { disable_filed = [] } = this.form
      if(typeof(field) != 'string'){
        let res = false
        field.map(item => {
          if(disable_filed.includes(item)){
            res = true
          }
        })
        return res
      }
      return disable_filed.includes(field)&&!!this.form[field]
    },
    getAddressForm(form, data) {
      // debugger
      this.subForm[form] = true
      this.formData = Object.assign(this.formData, data)
    },
    submitForm(otherData = {}) {

      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          Object.keys(this.subForm).some(key => {
            this.subForm[key] = false
            this.$refs[key].submitForm(key)
          })
          if (Object.values(this.subForm).some(item => item === false)) {
            return
          }
          let {benefits=[]} = this.formData||{}
          const uniqueArray = benefits.filter((value, index, self) => {
            return self.indexOf(value) === index
          })
          const result = {
            ...this.formData,
            benefits:uniqueArray
          }
          this.$emit('getFormData', result, otherData)
        }
        else {
          this.scrollToValidDom(rules)
        }
      })
    },
    getSaveSubmitForm(otherData = {}){
      this.otherData = otherData
      Object.keys(this.subForm).some(key => {
        this.subForm[key] = false
        this.$refs[key].submitFormNoVaild(key)
      })
      let {benefits=[]} = this.formData||{}
      const uniqueArray = benefits.filter((value, index, self) => {
        return self.indexOf(value) === index
      })
      const result = {
        ...this.formData,
        benefits:uniqueArray
      }
      this.$emit('getFormData', result, otherData)
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { idKey, nameKey, target, index = '', type } = otherData
      const { id, path } = data
      if(type !== 'other') {
        this.$set(this.formData, idKey, id)
        this.$set(this.formData, target, data)
        this.$set(this.formData, nameKey, path)
        // this.$set(this.formData, target, data)
        this.$refs['form'].validateField(idKey)
      }
      else {
        if(index === '') {
          this.formData.other_file.push(data)
        }
        else {
          this.$set(this.formData.other_file, index, data)
        }
      }
    },
    handlerDeleteFile({otherData}) {
      const { type, index,target,idKey,nameKey } = otherData
      this.$set(this.formData, idKey, '')
      this.$set(this.formData, target, {})
      this.$set(this.formData, nameKey, '')

    },
    handler() {
      return {
        handlerAddress: (data) => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const obj = {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          }
          const params = {}
          Object.keys(this.addressForm).some(key => {
            params[key] = data[key]
          })
          this.formDataLock += 1
          this.addressForm = JSON.parse(JSON.stringify(obj))
          // this.corAddressForm = JSON.parse(JSON.stringify(obj))
        },
        handlerAddressResult: data => {
          const {
            addr_room,
            addr_floor,
            addr_block,
            addr_building,
            addr_street,
            addr_district,
            addr_area,
            addr_region
          } = data
          const params = {
            cor_addr_room: addr_room,
            cor_addr_floor: addr_floor,
            cor_addr_block: addr_block,
            cor_addr_building: addr_building,
            cor_addr_street: addr_street,
            cor_addr_district: addr_district,
            cor_addr_area: addr_area,
            cor_addr_region: addr_region
          }
          Object.assign(this.formData, params)
        }
      }
    }
  }
}
</script>
